import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ElementRef,
  EventEmitter,
  Output,
  ContentChild,
  TemplateRef
} from '@angular/core';
import {ITreeTableHeader, ITreeTreeTableData} from './tree-table.model';
import {TreeFilterPipe} from '../commons/pipes/tree-filter-pipe/tree-filter.pipe';
import {GlobalSearchFilter} from '../commons/pipes/global-search-filter/global-search-filter.pipe';

@Component({
  selector: 'luci-tree-table',
  templateUrl: './luci-tree-table.component.html',
  styleUrls: ['./luci-tree-table.component.scss']
})
export class LuciTreeTableComponent implements OnInit, OnChanges {


  @Input() tableHeader: ITreeTableHeader[] = [];
  @Input() tableData: any[] = [];
  @Input() viewType = 'nested';
  @Input() noResultsMsg = '';
  @Input() isRefreshGrid = false;
  @Input() sortInfo: any = {};
  @Input() paginationPosition = '';
  @Input() paginationSize = 10;
  @Input() isHideColumns = false;
  @Input() isSearchable = false;
  @Input() isPagination = false;
  @Input() isSortable: boolean;
  @Input() restoreIcon = 'restore';
  @Input() filterIcon = 'filter';
  @Input() hideColumnsIcon = 'add';
  @Input() isReArrange = false;

  // toolbar props
  @Input() exportTypes = '';
  @Input() isSearch = '';
  @Input() isExport = '';
  @Input() isSearchRight = '';
  @Input() isToolbar = '';
  @Input() cstSeparator = '';
  @Input() fileName = '';
  @Input() pdfType = '';

  @Output() updateLinkDetails = new EventEmitter();
  @Output() refresh = new EventEmitter<any>();
  @Output() updateExport = new EventEmitter();

  @ContentChild(TemplateRef) templateRef: TemplateRef<any>;

  tableRows: any[] = [];
  expandList: any[] = [];
  sort: any = {
    order: '',
    field: ''
  };
  filteredColumns: any = {};
  showColumns = false;
  search: any = {};
  searchParam: any = [];

  disableUpdateColumnBtn = false;

  isSearchOpen = false;
  tableRowsData: any[] = [];
  dropDownOptions: any = {};
  searchFilter = new TreeFilterPipe();
  isPaginationReset = false;
  globalSearchFilter = new GlobalSearchFilter();
  reArrangeHeaders = [];

  constructor(private elRef: ElementRef) { }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.tableData) {
      if (this.viewType === 'nested') {
        this.updateNestedTable(changes.tableData.currentValue);
      } else {
        this.updateExpandedTable();
      }

    }
    if (this.isHideColumns && changes.tableHeader && changes.tableHeader.currentValue) {
      this.reArrangeHeaders = [...changes.tableHeader.currentValue];
      this.updateFilterColumns();
    }
  }

  updateNestedTable(tableData, parentId = null) {
    tableData.forEach((t, ) => {
      const obj: any = {...t};
      obj.parent = parentId;
      obj.subHeaders = this.tableHeader;
      this.tableRows.push(obj);
      if (obj.children  && obj.children.length > 0) {
        this.updateNestedTable(obj.children, obj.id);
      }
    });
  }

  updateExpandedTable() {
    this.tableRows = [];
    this.tableRowsData = [];
    this.search = {};
    this.searchParam = [];
    if (this.isSortable && this.sortInfo) {
      this.sort.order = this.sortInfo.order === 'asc' ? 'dsc' : 'asc';
      this.sortColumn(this.sortInfo.field, this.sortInfo.type, true);
    } else {
      this.tableData.forEach((t: any) => {
        const obj: any = {...t};
        this.tableRows.push(obj);
      });
    }

    this.tableRowsData = [...this.tableRows];
    this.updateDropdownList();
  }

  updatePage(pageInfo) {
    setTimeout(() => {
      this.tableRows = [...this.tableRowsData.slice(pageInfo.startIndex, pageInfo.endIndex + 1)];
      this.isPaginationReset = false;
    });
  }

  updateExpandList(row: ITreeTreeTableData) {
    if (this.expandList.indexOf(row.id) > -1) {
      this.expandList.splice(this.expandList.indexOf(row.id), 1);
      this.removeChildren(row.id);
    } else {
      this.expandList.push(row.id);
    }
  }

  removeChildren(id) {
    this.tableRows.forEach((r: any) => {
      if (r.parent === id && this.expandList.indexOf(r.id) > -1) {
        r.expanded = false;
        this.expandList.splice(this.expandList.indexOf(r.id), 1);
        this.removeChildren(r.id);
      }
    });
  }

  sortColumn(field, type, flag?) {
    this.search = {};
    this.searchParam = [];
    if (!this.sort.order || this.sort.order === 'dsc') {
      this.sort.order = 'asc';
    } else {
      this.sort.order = 'dsc';
    }
    this.sort.field = field;
    const sortData = this.tableData.sort((a: any, b: any) => {
      if (type === 'date') {
        const date1: any = a[field] ? new Date(a[field].slice(0, a[field].length - 3)) : null;
        const date2: any = b[field] ? new Date(b[field].slice(0, b[field].length - 3)) : null;
        if (date1 === date2) {
          return 0;
        } else if (date1 === null) {
          return 1;
        } else if (date2 === null) {
          return -1;
        } else if (this.sort.order === 'asc') {
          return date1 < date2 ? -1 : 1;
        } else {
          return date1 < date2 ? 1 : -1;
        }
      } else if (type === 'string') {
        const fieldA = a[field] ?  a[field].toLowerCase() : null;
        const  fieldB = b[field] ? b[field].toLowerCase() : null;
        const dateString: any =  a[field] ? new Date(a[field].slice(0, a[field].length - 3)) : null;
        if (fieldA === fieldB) {
          return 0;
        } else if (!(isNaN(fieldA) && !isNaN(Date.parse(dateString)))) {
          // string  number
          if (!(isNaN(fieldA))) {
            if (this.sort.order === 'asc') {
              return a[field] - b[field];
            } else {
              return b[field] - a[field];
            }
          } else {
            if (fieldA === null) {
              return 1;
            } else if (fieldB === null) {
              return -1;
            } else if (this.sort.order === 'asc') {
              return fieldA < fieldB ? -1 : 1;
            } else {
              return fieldA < fieldB ? 1 : -1;
            }
          }
        } else {
          // string date
          const date3: any = a[field] ? new Date(a[field].slice(0, a[field].length - 3)) : null;
          const date4: any = a[field] ? new Date(b[field].slice(0, b[field].length - 3)) : null;
          if (date3 === date4) {
            return 0;
          } else if (date3 === null) {
            return 1;
          } else if (date4 === null) {
            return -1;
          } else if (this.sort.order === 'asc') {
            return date3 < date4 ? -1 : 1;
          } else {
            return date3 < date4 ? 1 : -1;
          }
        }
      } else if (type === 'link') {
        const fieldA = a[field];
        const fieldB = b[field];
        const linkDateString: any =  a[field] ? new Date(a[field].slice(0, a[field].length - 3)) : null;
        if (fieldA === fieldB) {
          return 0;
        } else if (!(isNaN(fieldA) && !isNaN(Date.parse(linkDateString)))) {
          // link number and string
          if (!(isNaN(fieldA))) {
            if (this.sort.order === 'asc') {
              return a[field] - b[field];
            } else {
              return b[field] - a[field];
            }
          } else {
            const fieldA1 =  a[field] ?  a[field].toLowerCase() : null;
            const fieldB1 = b[field] ? b[field].toLowerCase() : null;
            if (fieldA1 === null) {
              return 1;
            } else if (fieldB1 === null) {
              return -1;
            } else if (this.sort.order === 'asc') {
              return fieldA1 !== fieldB1 ? fieldA1 < fieldB1 ? -1 : 1 : 0;
            } else {
              return fieldA1 !== fieldB1 ? fieldA1 > fieldB1 ? -1 : 1 : 0;
            }
          }

        } else {
          // link date
          const date1: any = a[field] ? new Date(a[field].slice(0, a[field].length - 3)) : null;
          const date2: any = a[field] ? new Date(b[field].slice(0, b[field].length - 3)) : null;
          if (date1 === date2) {
            return 0;
          } else if (date1 === null) {
            return 1;
          } else if (date2 === null) {
            return -1;
          } else if (this.sort.order === 'asc') {
            return date1 < date2 ? -1 : 1;
          } else {
            return date1 < date2 ? 1 : -1;
          }
        }
      } else {
        if (this.sort.order === 'asc') {
          return a[field] - b[field];
        } else {
          return b[field] - a[field];
        }
      }
    });
    if (!flag && this.isPagination) {
      if (sortData.length < this.paginationSize) {
        this.tableRowsData = [...sortData];
        this.noResultsMsg = '';
        this.updatePage({startIndex: 0, endIndex: sortData.length - 1});
      } else {
        this.tableRowsData = [...sortData];
        this.isPaginationReset = true;
      }
    } else {
      this.tableRows = [...sortData];
    }
  }

  goToLink(type, value, row?) {
    this.updateLinkDetails.emit({type, value, row});
  }

  updateColumns() {
    this.showColumns = false;
    const headers: ITreeTableHeader[] = [...this.reArrangeHeaders];
    headers.forEach((h: ITreeTableHeader) => {
      if (this.filteredColumns.hasOwnProperty(h.key)) {
        h.headerDisplay = this.filteredColumns[h.key];
      }
    });
    this.tableHeader = [...headers];
  }

  updateGlobalSearch(searchQuery){
    this.sort = {
      order: '',
      field: '',
      type: ''
    };
    const searchedItems = this.globalSearchFilter.transform(this.tableData, searchQuery);
    if (this.isPagination) {
      if (searchedItems.length < this.paginationSize) {
        this.tableRowsData = [...searchedItems];
        this.noResultsMsg = '';
        this.updatePage({startIndex: 0, endIndex: searchedItems.length - 1});
      } else {
        this.tableRowsData = [...searchedItems];
        this.isPaginationReset = true;
      }
    } else {
      this.tableRows = [...searchedItems];
    }
  }

  updateSearch($event, key: string) {
    const params = [...this.searchParam];
    this.search[key] = $event;
    if (params.indexOf(key) > -1) {
      params.splice(params.indexOf(key), 1);
      if ($event) {
        params.push(key);
      }
    } else {
      params.push(key);
    }
    this.searchParam = [...params];

    this.sort = {
      order: '',
      field: ''
    };
    const searchedItems = this.searchFilter.transform(this.tableData, this.searchParam, this.search);
    if (this.isPagination) {
      if (searchedItems.length < this.paginationSize) {
        this.tableRowsData = [...searchedItems];
        this.noResultsMsg = '';
        this.updatePage({startIndex: 0, endIndex: searchedItems.length - 1});
      } else {
        this.tableRowsData = [...searchedItems];
        this.isPaginationReset = true;
      }
    } else {
      this.tableRows = [...searchedItems];
    }
  }
  disableHideButton() {
    let displayHeaderCount = 0;
    this.tableHeader.forEach((h: ITreeTableHeader) => {
      if (this.filteredColumns.hasOwnProperty(h.key)) {
        displayHeaderCount = this.filteredColumns[h.key] ? displayHeaderCount + 1 : displayHeaderCount;
      } else {
        displayHeaderCount += 1;
      }
    });
    this.disableUpdateColumnBtn = displayHeaderCount < 3;
  }
  resetColumns() {
    this.tableHeader.forEach((h: ITreeTableHeader) => {
      this.filteredColumns[h.key] = true;
    });
    this.reArrangeHeaders = this.reArrangeHeaders.sort((h1, h2) => {
      return h1.id - h2.id;
    });
    this.disableUpdateColumnBtn = false;
  }

  updateFilterColumns() {
    this.tableHeader.forEach((h: ITreeTableHeader) => {
      this.filteredColumns[h.key] = h.headerDisplay;
    });
  }

  refreshGrid() {
    this.search = {};
    this.searchParam = [];
    this.refresh.emit();
  }

  updateDropdownList() {
    if (this.tableHeader && this.tableData) {
      const tableRows = [...this.tableData];
      this.tableHeader.forEach((h: any) => {
        if (h.selectedType === 'combo') {
          const arrangedData = tableRows.reduce((res, o) => {
            const obj = {
              name: o[h.key],
              value: o[h.key]
            };

            return res.findIndex(k => k.name === o[h.key]) < 0 ? [...res, obj] : res;
          }, []);

          const sotedData = arrangedData.sort((a, b) => {
            if (a.name === ' ' || a.name === '' || a.name === null) {
              return 1;
            }
            if (b.name === ' ' || b.name === '' || b.name === null) {
              return -1;
            }
            if (a.name === b.name) {
              return 0;
            }
            return a.name < b.name ? -1 : 1;
          });
          this.dropDownOptions[h.key] = sotedData;
        }
      });


    }
  }

  onHeaderDrop(event , header){
    const headers = [...this.reArrangeHeaders];
    const modifiedHeaders = [];
    headers.forEach((h) => {
      if (h.id === event.dragData.id) {
        modifiedHeaders.push(header);
      } else if (h.id === header.id) {
        modifiedHeaders.push(event.dragData);
      } else {
        modifiedHeaders.push(h);
      }
    });
    this.reArrangeHeaders = [...modifiedHeaders];
  }

  getIcon(icon) {
    return `assets/icons/luci.svg#${icon}`;
  }
}
